import React from 'react';

import { ReactComponent } from './weather-station-icon.svg';

export default function WeatherStationIcon() {
  return <ReactComponent />;
}
